import React, { useState } from "react";
import ColorInput from "../ColorInput";
import TextInput from "../TextInput";
import "./style.scss";
import { BuildSettingsKey } from "@builder/store/slices/buildSettingsKeys/buildSettingsKeySlice";
import TooltipElement from "../Tooltip";
import { useTranslation } from "react-i18next";

interface buildGlobalColorInputProps {
    id?: string;
    color?: string;
    name?: string;
    buildSettingsKey?: Partial<BuildSettingsKey>;
    callback: (color: string, name: string) => void;
    deleteCallback: () => void;
    bskCallback: (update: Partial<BuildSettingsKey>, globalColorId: string, bsk?: Partial<BuildSettingsKey>) => Promise<void>;
    deleteBSK: (bsk: Partial<BuildSettingsKey>, globalColorId: string, deleteGB?: boolean) => Promise<void>;
}

const BuildGlobalColorInput: React.FC<buildGlobalColorInputProps> = ({
    id,
    color,
    name,
    buildSettingsKey,
    callback,
    deleteCallback,
    bskCallback,
    deleteBSK
}: buildGlobalColorInputProps) => {
    const { t } = useTranslation();
    const [hex, setHex] = useState<string | undefined>(buildSettingsKey?.placeholder || color);
    const [colorName, setColorName] = useState<string | undefined>(name);

    // const colorCallback = (value: string) => {
    //     let validHex = value.replace(/[^0-9a-fA-F]/g, "").substring(0, 8);
    //     if (validHex && validHex[0] !== "#") {
    //         validHex = "#" + validHex;
    //     }
    //     setHex(validHex);
    //     callback(validHex, colorName || "");
    // };

    const nameCallback = (value: string) => {
        setColorName(value);
        callback(hex || "", value);
    };

    //eslint-disable-next-line
    const handleColorPickerChange = (hex: string) => {
        setHex(hex);
        callback(hex, colorName || "");
    };

    const handleBSKCallback = () => {
        if (id) {
            if (buildSettingsKey) {
                deleteBSK(buildSettingsKey, id);
            } else {
                bskCallback({ label: colorName, placeholder: hex }, id);
            }
        }
    };

    const handleDelete = () => {
        if (buildSettingsKey && id) {
            deleteBSK(buildSettingsKey, id, true);
        } else {
            deleteCallback();
        }
    };

    return (
        <div className="global-color-input-wrapper">
            <ColorInput key={id} color={hex} callback={handleColorPickerChange} options={{ noText: true, disableGlobalColors: true }} />
            <TextInput value={colorName || ""} placeholder="Color name" callback={nameCallback} />
            {/* <TextInput value={hex || ""} placeholder="#ffffff" callback={colorCallback} /> */}
            <TooltipElement text={t("tooltip.dynamic_color")}>
                <div className="toggle-bsk" onClick={() => handleBSKCallback()}>
                    {!!buildSettingsKey ? <img src="/BSK.svg" alt="" /> : <img src="/NoBSK.svg" alt="" />}
                </div>
            </TooltipElement>
            <div className="delete" onClick={() => handleDelete()}>
                <img src="/trash.svg" alt="" />
            </div>
        </div>
    );
};

export default BuildGlobalColorInput;
